<template>
  <div class="container mx-auto my-8 px-4">
    <Card class="p-8">
      <h1 class="text-4xl font-bold mb-4">{{ post.title }}</h1>
      <div class="text-lg text-muted-foreground">{{ post.body }}</div>
    </Card>

    <div
      v-if="currentUser && currentUser.admin"
      class="flex flex-col lg:flex-row gap-3 justify-between py-4 items-start"
    >
      <Button as="a" :href="postsPath" variant="outline">Back to posts</Button>
      <Button as="a" :href="editPostPath">Edit this post</Button>
      <div class="lg:grow"></div>
      <Button variant="destructive" @click="destroyForm.delete(postPath)">
        Destroy this post
      </Button>
    </div>
  </div>
</template>

<script setup>
import { useForm } from "@inertiajs/vue3";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const props = defineProps({
  post: { type: Object, required: true },
  currentUser: { type: Object, default: null },
  postsPath: { type: String, required: true },
  editPostPath: { type: String, default: "" },
  postPath: { type: String, required: true },
});

const destroyForm = useForm({});
</script>
